'use client';

import Spinner, { WidgetSizeEnum } from './Spinner';

interface Props {
  text?: string;
}

export default function Loader({ text = 'Loading' }: Props) {
  return (
    <div className="space-y-10">
      <div className="flex justify-center">
        <img className="max-w-96" src="../images/town-vector.svg" alt="town vector" />
      </div>
      <div className="flex flex-row items-center gap-x-3.5 justify-center">
        <div>
          <Spinner size={WidgetSizeEnum.SMALL} spinnerColor="blue" overlayColor="blue" />
        </div>
        <div className="text-xl text-gray-900">{text}</div>
      </div>
    </div>
  );
}
